module.exports = __webpack_public_path__ + "img/valuationResultBase.04b45ee2.png";